import type { UseFormRegister, FieldErrors } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Utensils } from "lucide-react";
import { Input, MultiSelect } from "@/components/ui";
import { SectionCard } from "@/components/common";
import { getCuisineSelectOptions } from "@/constants";
import type { ActivityDetailFormValues } from "../activityDetailForm";

interface RestaurantConfigSectionProps {
  cuisineTypes: string[];
  onCuisineTypesChange: (types: string[]) => void;
  register: UseFormRegister<ActivityDetailFormValues>;
  errors: FieldErrors<ActivityDetailFormValues>;
  modified: boolean;
}

export function RestaurantConfigSection({
  cuisineTypes,
  onCuisineTypesChange,
  register,
  errors,
  modified,
}: RestaurantConfigSectionProps) {
  const { t: tComponents } = useTranslation("components");
  const { t } = useTranslation("activities");
  const cuisineOptions = getCuisineSelectOptions();

  return (
    <SectionCard
      title={t("restaurantConfig.title")}
      icon={Utensils}
      modified={modified}
    >
      <div className="grid gap-4 sm:grid-cols-2">
        <MultiSelect
          placeholderLabel={t("restaurantConfig.cuisinePlaceholder")}
          removeChipLabel={(chipLabel) =>
            tComponents("multiSelectRemoveChip", { label: chipLabel })
          }
          label={t("restaurantConfig.cuisineTypes")}
          options={cuisineOptions}
          value={cuisineTypes}
          onChange={onCuisineTypesChange}
          hint={t("restaurantConfig.cuisineHint")}
        />
        <Input
          {...register("avg_price_per_person")}
          type="number"
          min="0"
          label={t("restaurantConfig.avgPriceLabel")}
          placeholder={t("restaurantConfig.avgPricePlaceholder")}
          error={errors.avg_price_per_person?.message}
          hint={t("restaurantConfig.avgPriceHint")}
        />
      </div>
    </SectionCard>
  );
}
